import { useCallback, useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import screens from 'screens.json';

export const useResponsive = () => {
  const sm = useMediaQuery({ query: `(min-width: ${screens.sm})` });
  const md = useMediaQuery({ query: `(min-width: ${screens.md})` });
  const lg = useMediaQuery({ query: `(min-width: ${screens.lg})` });
  const xl = useMediaQuery({ query: `(min-width: ${screens.xl})` });
  return useMemo(
    () => ({
      sm,
      md,
      lg,
      xl
    }),
    [sm, md, lg, xl]
  );
};

export const useFileInput = (initialUrl = '') => {
  const [fileUrl, setFileUrl] = useState(initialUrl);
  const handleFileInputChange = useCallback(evt => {
    evt.preventDefault();
    const [file] = evt.target.files;
    const reader = new FileReader();
    reader.onloadend = () => {
      setFileUrl(reader.result as string);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  }, []);
  return useMemo(
    () => ({
      fileUrl,
      setFileUrl,
      handleFileInputChange
    }),
    [handleFileInputChange, fileUrl]
  );
};
